import * as data from '../../app-version.json'

const releaseDate = data.releaseDate

export default releaseDate
